/**
 * @file header-state.component.tsx
 * @description Компонент индикатора состояния в заголовке формы объекта для Task Manager приложения, который обеспечивает отображение и изменение статуса объекта через интерактивный badge. Интегрируется с react-hook-form для управления значением состояния, открывает модальное окно HeaderStateModal для выбора нового состояния, поддерживает Controller для связи с формой и автоматического обновления значений при изменении статуса объекта.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['react', '@components/form-controls/badge', '@forms/modals', 'react-hook-form']
 * @related-files ['src/features/object-form/components/header.component.tsx', 'src/components/form-controls/badge', 'src/forms/modals/header-state.tsx']
 */

import { useState } from 'react';
import { Badge } from '@components/form-controls/badge';
import { HeaderState as HeaderStateModal } from '@forms/modals';
import { Controller } from 'react-hook-form';

export const HeaderState = ({ control, container, name = 'state' }: any) => {
    const [isShowModal, setIsShowModal] = useState(false);

    return (
        <>
            <Badge size="s" onClick={() => setIsShowModal(true)} control={control} name={name} />

            {isShowModal && (
                <Controller
                    name={name}
                    control={control}
                    render={({ field }: any) => (
                        <HeaderStateModal
                            setIsShow={setIsShowModal}
                            container={container}
                            value={field.value}
                            onChange={field.onChange}
                        />
                    )}
                />
            )}
        </>
    );
};
